<app-header></app-header>

<div class="container-fluid" style="width: 80%; min-height: 600px">

  <div class="row mt-4 mb-4">
    <div class="col">
      <nav class="breadcrumb-container" aria-label="Percorso di navigazione">
        <ol class="breadcrumb mb-0 p-0">
          <li class="breadcrumb-item"><a routerLink="/home">Home</a><span class="separator">/</span></li>
          <li class="breadcrumb-item"><a routerLink="/home">Admin</a><span class="separator">/</span></li>
          <li class="breadcrumb-item active" aria-current="page">Richieste valutazione inviate</li>
        </ol>
      </nav>
    </div>
  </div>

  <div class="row mt-4 mb-4">
    <div class="col">
      <h4>Richieste valutazione assistito – tutte le operazioni</h4>
      <p class="text-muted small mb-0">Elenco di tutte le richieste inviate (POST /richiesta-valutazione-assistito) e il loro stato di elaborazione.</p>
    </div>
  </div>

  <mat-card class="p-2" appearance="outlined">
    <mat-card-content>
      @if (caricamento && items.length === 0) {
        <div class="text-center py-4">
          <mat-spinner diameter="40"></mat-spinner>
          <p class="mt-2 mb-0">Caricamento...</p>
        </div>
      } @else if (errore && items.length === 0) {
        <p class="text-danger">{{ errore }}</p>
      } @else {
        <p class="mb-3"><b>{{ totalElements }}</b> operazioni totali</p>
        <table mat-table [dataSource]="items" class="w-100">
          <ng-container matColumnDef="operationId">
            <th mat-header-cell *matHeaderCellDef>ID operazione</th>
            <td mat-cell *matCellDef="let row"><code class="small">{{ row.operationId }}</code></td>
          </ng-container>
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Stato</th>
            <td mat-cell *matCellDef="let row">
              <span class="badge" [class.bg-secondary]="row.status === 'PENDING'" [class.bg-primary]="row.status === 'RUNNING'" [class.bg-success]="row.status === 'SUCCEEDED'" [class.bg-danger]="row.status === 'FAILED'">
                {{ statusLabel(row.status) }}
              </span>
            </td>
          </ng-container>
          <ng-container matColumnDef="errorMessage">
            <th mat-header-cell *matHeaderCellDef>Motivo fallimento</th>
            <td mat-cell *matCellDef="let row">
              @if (row.status === 'FAILED' && row.errorMessage) {
                <span class="text-danger small">{{ row.errorMessage }}</span>
              } @else {
                <span class="text-muted small">—</span>
              }
            </td>
          </ng-container>
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Azioni</th>
            <td mat-cell *matCellDef="let row">
              <button mat-button color="primary" (click)="openStatoFhirPopup(row.operationId)">
                <mat-icon>info</mat-icon> Stato (FHIR)
              </button>
              <button mat-button (click)="refreshRow(row)">
                <mat-icon>refresh</mat-icon> Aggiorna
              </button>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" [attr.colspan]="displayedColumns.length">
              Nessuna operazione trovata.
            </td>
          </tr>
        </table>
        <mat-paginator [length]="totalElements" [pageIndex]="pageIndex" [pageSize]="pageSize"
          [pageSizeOptions]="pageSizeOptions" (page)="onPage($event)" showFirstLastButtons
          aria-label="Seleziona pagina">
        </mat-paginator>
      }
    </mat-card-content>
  </mat-card>

</div>

<app-footer></app-footer>
